import {
  ESummaryColor,
  ISummaryConfig
} from '@modules/projects/modules/project-changes/shared/interfaces/summary-config.interface';
import { ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-toggle',
  templateUrl: './summary-toggle.component.html',
  styleUrls: ['./summary-toggle.component.scss']
})
export class SummaryToggleComponent {
  @Input() summary: any;
  @Input() summaryOpened: boolean = false;
  @Input() summaryConfig: ISummaryConfig = null;
  @Input() invertCostColors = false;

  constructor(private changes: ChangeDetectorRef) {}

  toggleSummary() {
    this.summaryOpened = !this.summaryOpened;
    this.changes.detectChanges();
  }

  get displayedSummaryConfig(): ISummaryConfig {
    if (!this.summaryConfig) {
      return null;
    }

    return {
      ...this.summaryConfig,
      items: this.summaryConfig.items?.map((box) => ({
        ...box,
        items: box.items?.map((item) => ({
          ...item,
          color: this.resolveCostColor(item.title, item.color)
        })),
        total: box.total
      }))
    };
  }

  private resolveCostColor(title: string, color?: ESummaryColor) {
    if (title === 'ProjectChanges.Summary.increaseBudget') {
      return this.invertCostColors ? ESummaryColor.RED : ESummaryColor.GREEN;
    }

    if (title === 'ProjectChanges.Summary.decreaseBudget') {
      return this.invertCostColors ? ESummaryColor.GREEN : ESummaryColor.RED;
    }

    return color;
  }
}
